import AxiosInterceptor from "api/interceptor";

const region = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    return region.get("/regions", { params: qstr });
  },
  find(id) {
    return region.get("/regions/" + id);
  },
  create(inputs) {
    return region.post("/regions", inputs);
  },
  update(id, inputs) {
    return region.put("/regions/" + id, inputs);
  },
  delete(id) {
    return region.delete("/regions/" + id);
  }
};
